package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.NotificationsW500Rounded: ImageVector
    get() {
        if (_notificationsW500Rounded != null) {
            return _notificationsW500Rounded!!
        }
        _notificationsW500Rounded = Builder(name = "NotificationsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(197.37f, 768.13f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                lineTo(229.0f, 677.13f)
                verticalLineToRelative(-271.87f)
                quadToRelative(0.0f, -86.11f, 51.32f, -153.6f)
                quadToRelative(51.31f, -67.49f, 134.18f, -88.2f)
                verticalLineToRelative(-26.09f)
                quadToRelative(0.0f, -27.39f, 19.05f, -46.45f)
                quadToRelative(19.06f, -19.05f, 46.45f, -19.05f)
                quadToRelative(27.39f, 0.0f, 46.45f, 19.05f)
                quadToRelative(19.05f, 19.06f, 19.05f, 46.45f)
                verticalLineToRelative(26.09f)
                quadToRelative(83.11f, 20.71f, 134.3f, 88.08f)
                quadTo(731.0f, 318.91f, 731.0f, 405.26f)
                verticalLineToRelative(271.87f)
                horizontalLineToRelative(31.63f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(197.37f, 768.13f)
                close()
                moveTo(480.0f, 461.2f)
                close()
                moveTo(480.24f, 890.76f)
                quadToRelative(-34.2f, 0.0f, -58.53f, -24.22f)
                quadToRelative(-24.34f, -24.21f, -24.34f, -58.41f)
                horizontalLineToRelative(165.5f)
                quadToRelative(0.0f, 34.2f, -24.22f, 58.41f)
                quadToRelative(-24.22f, 24.22f, -58.41f, 24.22f)
                close()
                moveTo(320.0f, 677.13f)
                horizontalLineToRelative(320.0f)
                verticalLineToRelative(-271.87f)
                quadToRelative(0.0f, -66.0f, -47.0f, -113.0f)
                reflectiveQuadToRelative(-113.0f, -47.0f)
                quadToRelative(-66.0f, 0.0f, -113.0f, 47.0f)
                reflectiveQuadToRelative(-47.0f, 113.0f)
                verticalLineToRelative(271.87f)
                close()
            }
        }
        .build()
        return _notificationsW500Rounded!!
    }

private var _notificationsW500Rounded: ImageVector? = null
